import type { HeaderFeatures } from './type';

export const header: HeaderFeatures = {
    customerEntities: {
        enabled: false,
    },
    plugins: {
        enabled: true,
        _description: 'Display/hide "Your Extras" option in the main navigation.',
        searchAndBuyPromo: {
            enabled: true,
        },
    },
};
